/** @format */

import template from './gb-profile-honour-roll.html';
import './gb-profile-honour-roll.scss';

export const GbProfileHonourRollComponent = {
    template,
    require: {
        gbWidget: '^^',
        gbHonourRollWidget: '^^',
    },
    bindings: {
        honourRollActivity: '<',
        index: '<',
        transition: '<',
        setObservable: '<',
        setRendered: '&',
    },
    controller: class GbProfileHonourRollComponent {
        constructor($ccColors, $translate, $element, $filter) {
            'ngInject';

            this.$ccColors = $ccColors;
            this.$translate = $translate;
            this.$element = $element;
            this.$filter = $filter;
            this.cardStyles = {};
            this.primaryStyles = {};
            this.accentStyles = {};

            this.itemTypeText = {
                bidding: this.$translate.instant('ITEM_TYPE_SILENT_AUCTION'),
                live: this.$translate.instant('ITEM_TYPE_LIVE_AUCTION'),
                sealed: this.$translate.instant('ITEM_TYPE_SEALED_AUCTION'),
                donation: this.$translate.instant('ITEM_TYPE_DONATION'),
                raffle: this.$translate.instant('ITEM_TYPE_RAFFLE'),
                purchase: this.$translate.instant('ITEM_TYPE_PURCHASE'),
            };
        }

        $onInit() {
            if (this.setObservable) {
                this.setIntersectionObserverOutOfView();
            }
        }

        setIntersectionObserverOutOfView() {
            if ('IntersectionObserver' in window) {
                const element = this.$element[0];

                this.observer = new IntersectionObserver(this.observerCallbackOutOfView.bind(this), {
                    threshold: 0,
                    trackVisibility: true,
                    delay: 100,
                });
                this.observer.observe(element);
            }
        }

        isHorizontalScroll() {
            return this.transition === 'scroll-left' || this.transition === 'scroll-right';
        }

        observerCallbackOutOfView(entries) {
            if (entries) {
                entries.forEach((entry) => {
                    if (['scroll-right', 'scroll-bottom'].includes(this.transition)) {
                        // for right to left and top to bottom
                        if (!entry.isVisible && entry.intersectionRatio > 0) {
                            this.setRendered({
                                index: this.index,
                            });
                        }
                    } else {
                        // for left to right and bottom to top scroll
                        if (entry.intersectionRatio === 0) {
                            this.setRendered({
                                index: this.index,
                            });
                        }
                    }
                });
            }
        }

        getCardStyles() {
            let bgColor = this.gbWidget.widget.table_background_color;

            if (bgColor) {
                this.cardStyles['background-color'] = bgColor;
                this.cardStyles['color'] = this.$ccColors.getContrast(bgColor);
            }

            return this.cardStyles;
        }

        getAccentStyles() {
            let bgColor = this.gbWidget.widget.table_primary_color;

            if (bgColor) {
                this.accentStyles['border-left-color'] = bgColor;
            }

            return this.accentStyles;
        }

        getHonourRollText() {
            let itemType = this.honourRollActivity && this.honourRollActivity.item_type;

            const activity = this.honourRollActivity;

            if (!itemType) {
                return;
            } else if (itemType === 'bidding') {
                return this.$translate.instant(this.getBidTranslateLabel(), {
                    profile_full_name: activity.profile_full_name,
                    amount: this.$filter('gbAuctionCurrency')(activity.amount),
                    item_name: activity.item_name,
                    item_alias: activity.item_alias,
                });
            } else if (itemType === 'raffle') {
                return this.$translate.instant(this.getRafflePurchaseTranslateLabel(), {
                    profile_full_name: activity.profile_full_name,
                    quantity: activity.quantity,
                    item_name: activity.item_name,
                    item_alias: activity.item_alias,
                });
            } else if (itemType === 'purchase') {
                return this.$translate.instant(this.getPurchaseTranslateLabel(), {
                    profile_full_name: activity.profile_full_name,
                    quantity: activity.quantity,
                    item_name: activity.item_name,
                    item_alias: activity.item_alias,
                });
            } else if (itemType === 'donation') {
                return this.$translate.instant(this.getDonationTranslateLabel(), {
                    profile_full_name: activity.profile_full_name,
                    amount: this.$filter('gbAuctionCurrency')(activity.amount),
                    item_name: activity.item_name,
                    item_alias: activity.item_alias,
                });
            } else {
                return '';
            }
        }

        getBidTranslateLabel() {
            if (this.gbWidget.widget.show_item_name && !this.gbWidget.widget.show_item_alias) {
                return 'HONOUR_ROLL_BID_TEXT_ITEM_NAME';
            } else if (!this.gbWidget.widget.show_item_name && this.gbWidget.widget.show_item_alias) {
                return 'HONOUR_ROLL_BID_TEXT_ITEM_ALIAS';
            } else if (this.gbWidget.widget.show_item_name && this.gbWidget.widget.show_item_alias) {
                return 'HONOUR_ROLL_BID_TEXT_ITEM_NAME_ALIAS';
            } else {
                return 'HONOUR_ROLL_BID_TEXT';
            }
        }

        getRafflePurchaseTranslateLabel() {
            if (this.honourRollActivity.quantity === 1) {
                if (this.gbWidget.widget.show_item_name && !this.gbWidget.widget.show_item_alias) {
                    return 'HONOUR_ROLL_RAFFLE_PURCHASE_TEXT_SINGLE_ITEM_NAME';
                } else if (!this.gbWidget.widget.show_item_name && this.gbWidget.widget.show_item_alias) {
                    return 'HONOUR_ROLL_RAFFLE_PURCHASE_TEXT_SINGLE_ITEM_ALIAS';
                } else if (this.gbWidget.widget.show_item_name && this.gbWidget.widget.show_item_alias) {
                    return 'HONOUR_ROLL_RAFFLE_PURCHASE_TEXT_SINGLE_ITEM_NAME_ALIAS';
                } else {
                    return 'HONOUR_ROLL_RAFFLE_PURCHASE_TEXT_SINGLE';
                }
            } else {
                if (this.gbWidget.widget.show_item_name && !this.gbWidget.widget.show_item_alias) {
                    return 'HONOUR_ROLL_RAFFLE_PURCHASE_TEXT_MULTIPLE_ITEM_NAME';
                } else if (!this.gbWidget.widget.show_item_name && this.gbWidget.widget.show_item_alias) {
                    return 'HONOUR_ROLL_RAFFLE_PURCHASE_TEXT_MULTIPLE_ITEM_ALIAS';
                } else if (this.gbWidget.widget.show_item_name && this.gbWidget.widget.show_item_alias) {
                    return 'HONOUR_ROLL_RAFFLE_PURCHASE_TEXT_MULTIPLE_ITEM_NAME_ALIAS';
                } else {
                    return 'HONOUR_ROLL_RAFFLE_PURCHASE_TEXT_MULTIPLE';
                }
            }
        }

        getPurchaseTranslateLabel() {
            if (this.gbWidget.widget.show_item_name && !this.gbWidget.widget.show_item_alias) {
                return 'HONOUR_ROLL_PURCHASE_TEXT_ITEM_NAME';
            } else if (!this.gbWidget.widget.show_item_name && this.gbWidget.widget.show_item_alias) {
                return 'HONOUR_ROLL_PURCHASE_TEXT_ITEM_ALIAS';
            } else if (this.gbWidget.widget.show_item_name && this.gbWidget.widget.show_item_alias) {
                return 'HONOUR_ROLL_PURCHASE_TEXT_ITEM_NAME_ALIAS';
            } else {
                return 'HONOUR_ROLL_PURCHASE_TEXT';
            }
        }

        getDonationTranslateLabel() {
            if (this.gbWidget.widget.show_item_name && !this.gbWidget.widget.show_item_alias) {
                return 'HONOUR_ROLL_DONATION_TEXT_ITEM_NAME';
            } else if (!this.gbWidget.widget.show_item_name && this.gbWidget.widget.show_item_alias) {
                return 'HONOUR_ROLL_DONATION_TEXT_ITEM_ALIAS';
            } else if (this.gbWidget.widget.show_item_name && this.gbWidget.widget.show_item_alias) {
                return 'HONOUR_ROLL_DONATION_TEXT_ITEM_NAME_ALIAS';
            } else {
                return 'HONOUR_ROLL_DONATION_TEXT';
            }
        }

        shouldShowRow() {
            return this.honourRollActivity && this.honourRollActivity.item_name;
        }
    },
};
